<template>
  <div class="">
    <div class="columns is-mobile is-centered is-vcentered">
      <div class="column is-3">
        <b-image
          :src="require('@/assets/logo.svg')"
          alt="qlipmark"
          class="logo"
        />
      </div>
      <div class="column is-flex-grow-0 has-text-primary logo-text">
        qlipmark
      </div>
    </div>
    <form @submit.prevent="onSubmit">
      <b-field>
        <b-input
          v-model="form.email"
          type="email"
          placeholder="email"
          size="is-medium"
          autofocus=""
          required
        />
      </b-field>

      <b-field>
        <b-input
          v-model="form.password"
          type="password"
          placeholder="password"
          size="is-medium"
          autofocus=""
          required
        />
      </b-field>
      <button class="button is-block is-primary is-medium is-fullwidth submit-button">
        Login
        <!-- <i
          class="fa fa-sign-in-alt"
          aria-hidden="true"
        /> -->
      </button>
    </form>
    <p class="mt-5 has-text-centered has-text-grey">
      <router-link :to="{name: 'SignUp'}">
        Sign Up
      </router-link>
      &nbsp;-&nbsp;
      <router-link :to="{name: 'SendResetPassword'}">
        Recover
      </router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  props: {
    prevPath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      email: { required, email },
      password: { required }
    }
  },
  methods: {
    ...mapGetters({
      user: 'auth/user'
    }),
    ...mapActions({
      login: 'auth/login'
    }),
    onSubmit () {
      this.login(this.form).then((results) => {
        let path =  this.prevPath
        if (path == '' && this.$route.query.prevPath) {
          path = this.$route.query.prevPath
        }

        // remove the backing / if existent
        path = path.replaceAll(/^\//g,'')

        if (!path.length){ 
          this.$router.push({name: 'Home'})
          return
        }
        if(path.indexOf("ext-") === 0 ){ 
          // redirect back to extension
          if(window.chrome){
            let extId = path.split("-")[1]
            window.chrome.runtime.sendMessage(extId, { method: "loginSuccess", userId: results.id });
          }
          else{
            this.$router.push({name: 'Home'})
          }
        }
        else{
          this.$router.push({path: `/${path}`})
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

